import React, { useState } from 'react';
import QuestionsForm from './QuestionsForm';
import SupportConfirmation from './SupportConfirmation';
import { surveySupportMeasures } from './SupportConfirmationService';
import Loading from '../../../../components/Loading';
import { apiResponseWrapper } from '../../../../utils/apiResponseWrapper';
import { scrollToFirstFormError } from '../../../Taps/utils/scrollToFormError/scrollToFormError';

function Index() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div className={'boo'}>
      {isSubmitted ? (
        <SupportConfirmation />
      ) : (
        <>
          {isLoading && <Loading />}
          <QuestionsForm
            onSubmitFail={(e) => setTimeout(() => scrollToFirstFormError(e), 0)}
            onSubmit={async (values) => {
              setIsLoading(true);
              try {
                const res = await surveySupportMeasures(values.toJS());
                apiResponseWrapper(res);
                setIsSubmitted(true);
              } finally {
                setIsLoading(false);
              }
            }}
          />
        </>
      )}
    </div>
  );
}

export default Index;
